export default __webpack_public_path__ + "5ce03464de42b0a19cceb51acac3326d.svg";